'use client'
import { DotLottieReactProps } from '@lottiefiles/dotlottie-react'
import dynamic from 'next/dynamic'
import { Suspense } from 'react'
import Spinner from './Spinner'

const DotLottieReact = dynamic(
    () => import('@lottiefiles/dotlottie-react').then((m) => m.DotLottieReact),
    {
        // loading: () => <p>Loading...</p>,
        ssr: false,
    }
)

export const Lottie = ({ path, ...props }: { path: string } & DotLottieReactProps) => {
    return (
        <Suspense fallback={<Spinner />}>
            <DotLottieReact src={`/lotties/${path}.lottie`} loop autoplay {...props} />
        </Suspense>
    )
}
